const currencyMap = { 980: 'UAH', 840: 'USD', 978: 'EUR' };
const defaultRate = 43.5831;

async function fetchExchangeRatesOnce() {
  const cached = sessionStorage.getItem('monobankRates');
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      // console.log('[currency.js] Cached rates found:', parsed);
      if (Array.isArray(parsed)) return parsed;
    } catch (err) {
      console.warn('[currency.js] Failed to parse cached rates', err);
    }
  }
  try {
    // console.log('[currency.js] Fetching rates from Monobank...');
    const res = await fetch('https://api.monobank.ua/bank/currency');
    const data = await res.json();
    // console.log('[currency.js] Monobank API response:', data);
    if (Array.isArray(data)) {
      sessionStorage.setItem('monobankRates', JSON.stringify(data));
      return data;
    }
    console.error('[currency.js] Monobank returned error:', data);
    return null;
  } catch (e) {
    console.error('[currency.js] Fetch failed, using default rates:', e);
    return null;
  }
}

function parseRates(rates) {
  if (!Array.isArray(rates)) {
    console.error('[currency.js] Invalid rates format, using default rates');
    return {};
  }
  const parsed = {};
  rates.forEach(rate => {
    const a = currencyMap[rate.currencyCodeA],
        b = currencyMap[rate.currencyCodeB];
    if (a && b) {
      parsed[`${a}_${b}`] = rate.rateBuy || rate.rateCross;
      parsed[`${b}_${a}`] = 1 / (rate.rateSell || rate.rateCross);
    }
  });
  // console.log('[currency.js] Parsed rates:', parsed);
  return parsed;
}

function convert(amount, from, to, rates) {
  const key = `${from}_${to}`;
  const rate = rates[key] || defaultRate;
  // console.log(`[currency.js] Converting ${amount} ${from} -> ${to} using rate ${rate}`);
  return rates[key] ? amount * rate : amount * defaultRate;
}

function formatCodeAfter(amount, currency) {
  const nf = new Intl.NumberFormat('en-US', {
    style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0, currencyDisplay: 'code'
  });
  const parts = nf.formatToParts(amount);
  const numberStr = parts.filter(p => p.type !== 'currency' && p.type !== 'literal').map(p => p.value).join('');
  return `${numberStr} ${currency}`;
}


function getCurrencyFromSelector() {
  const selectedEl = document.querySelector('.header-currency-selected span');
  if (!selectedEl) return 'UAH';
  const text = selectedEl.textContent.trim();
  if (text == "ENG") return 'USD';
  if (text == "UKR") return 'UAH';
  if (text == "FRA") return 'EUR';
  if (text == "DEU") return 'EUR';
  if (text == "POL") return 'EUR';
  if (text == "ESP") return 'EUR';
}


async function updatePrices() {
  // OLD variant with cookie
  // const preferredCurrency = document.cookie.match(/(?:^|; )currency=([^;]*)/)?.[1] || 'UAH';

  const preferredCurrency = getCurrencyFromSelector();

  // console.log(preferredCurrency);

  if (preferredCurrency !== 'USD' && preferredCurrency !== 'EUR') {
    return;
  }

  const rawRates = await fetchExchangeRatesOnce();
  const rates = rawRates ? parseRates(rawRates) : { 'UAH_USD': 1 / defaultRate, 'USD_UAH': defaultRate };

  window.rates = rates;

  document.querySelectorAll('.custom-price, .product-price, .js-product-price').forEach(el => {
    if (el.dataset.lastWriter === 'updateProductPrice') {
      // console.log('[currency.js] Skipping element modified by updateProductPrice:', el);
      return;
    }

    const base = parseFloat(el.dataset.basePrice);
    if (isNaN(base)) {
      console.warn('[currency.js] Invalid base price for element:', el);
      return;
    }

    // Перевірка чи вже правильна валюта
    if (el.textContent.trim().endsWith(preferredCurrency)) {
      // console.log('[currency.js] Currency already correct, skipping:', el);
      return;
    }

    const converted = Math.round(convert(base, 'UAH', preferredCurrency, rates));
    el.textContent = formatCodeAfter(converted, preferredCurrency);
    el.dataset.lastWriter = 'currency.js';
    // console.log(`[currency.js] Updated price: base ${base} UAH -> ${el.textContent}`);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // console.log('[currency.js] DOM ready, running updatePrices...');
  updatePrices();
});

const observer = new MutationObserver(muts => {
  for (const m of muts) {
    if ([...m.addedNodes].some(n => n.nodeType === 1 && n.querySelector?.('.custom-price'))) {
      // console.log('[currency.js] Detected new .custom-price element(s), updating...');
      updatePrices();
      break;
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
